/* eslint-disable no-restricted-imports */
import TagManager from 'react-gtm-module';

import config, { isProd, isStaging } from '../../config';
import { isOptedOutForSession } from '../../utils/privacy';

export const initializeTagManager = () => {
  if (isOptedOutForSession()) {
    return;
  }

  if (isStaging || isProd) {
    const tagManagerArgs = {
      gtmId: config.gtm.gtmId,
      auth: config.gtm.auth,
      preview: config.gtm.preview,
    };

    TagManager.initialize(tagManagerArgs);
  }
};

export enum GTMEvent {
  StartFlow = 'start_flow',
  Lead = 'lead',
  EnhancedLead = 'enhanced_lead',
  FinishFlow = 'finish_flow',
}

const track = (event: GTMEvent, data?: Record<string, unknown>) => {
  if (isOptedOutForSession()) {
    return;
  }

  TagManager.dataLayer({
    dataLayer: {
      event,
      ...data,
    },
  });
};

export const GTM = {
  track,
};
